const completeStatusImage =
  'https://public-asset-cdn.ecovation.vn/master/zalo-template/zalo_complete_status_450_450.webp';
const deliveryStatusImage =
  'https://public-asset-cdn.ecovation.vn/master/zalo-template/zalo_delivery_status_450_450.webp';
const pendingStatusImage =
  'https://public-asset-cdn.ecovation.vn/master/zalo-template/zalo_pending_status_450_450.webp';
const zaloCustomerImage =
  'https://public-asset-cdn.ecovation.vn/master/zalo-template/zalo_customer_450_450.jpeg';

import { ORDER_STATUS } from 'utils/constants';

const option = {
  isVisible: true,
  whiteList: ['order', 'take', 'page', 'where'],
};

const ACTION_TYPE = {
  CHANGE_STATUS: 'CHANGE_STATUS',
  DELETE: 'DELETE',
};

const statusList = [
  { key: '0', value: 'all', name: 'Tất cả các trạng thái' },
  { key: '1', value: 0, name: 'Đang hoạt động' },
  { key: '2', value: 1, name: 'Dừng hoạt động' },
];

const areaTypeList = [
  { key: '0', value: '0', name: 'Vùng sản xuất' },
  { key: '1', value: '1', name: 'Vùng nuôi trồng' },
  { key: '2', value: '2', name: 'Vùng chế biến' },
  { key: '3', value: '3', name: 'Vùng sản xuất và nuôi trồng' },
  { key: '4', value: '4', name: 'Vùng sản xuất và chế biến' },
  { key: '5', value: '5', name: 'Loại khác' },
];

const skeletonData = [
  {
    title: 'Mã SKU',
    type: 'input',
    width: 130,
  },
  {
    title: 'Tên loại sản phẩm',
    type: 'image',
    width: 100,
  },
  {
    title: 'Ngày tạo',
    type: 'input',
    width: 70,
  },
  {
    title: 'Số lượng',
    type: 'input',
    width: 50,
  },
  {
    title: 'Thao tác',
    type: 'input',
    width: 120,
  },
];

const CONNECT_ZALO_SKELETON = [
  {
    title: 'ID Zalo OA',
    type: 'input',
    width: 200,
  },
  {
    title: 'Tên Zalo OA',
    type: 'avatar',
    width: 150,
  },
  {
    title: 'Gói sử dụng',
    type: 'input',
    width: 100,
  },
  {
    title: 'Trạng thái',
    type: 'input',
    width: 100,
  },
  {
    title: 'Ngày kết nối',
    type: 'input',
    width: 100,
  },
  {
    type: 'input',
    width: 120,
  },
];

const ZALO_NOTIFICATION_SETTING_SKELETON = [
  {
    title: 'Tiêu đề',
    type: 'input',
    width: 200,
  },
  {
    title: 'Chi nhánh',
    type: 'input',
    width: 150,
  },
  {
    title: 'Ngày tạo',
    type: 'input',
    width: 100,
  },
  {
    title: 'Trạng thái',
    type: 'input',
    width: 100,
  },
  {
    type: 'input',
    width: 120,
  },
];

const NOTIFICATION_ZALO_SETTING_FORM = [
  {
    status: ORDER_STATUS.PENDING,
    title: 'Xác nhận đặt hàng',
    description:
      'Chúc mừng bạn đã đặt hàng thành công tại {TEN_NHA_CUNG_CAP}. Đơn hàng #{MA_DON_HANG} của bạn có tổng tiền là {TONG_TIEN} đã được xác nhận và đang trong quá trình xử lý.',
    totalPrice: 700,
    image: pendingStatusImage,
  },
  {
    status: ORDER_STATUS.DELIVERY,
    title: 'Giao hàng',
    description:
      'Đơn hàng #{MA_DON_HANG} gửi từ {TEN_NHA_CUNG_CAP} đang được giao đến bạn với tổng số tiền là {TONG_TIEN}.',
    totalPrice: 700,
    image: deliveryStatusImage,
  },
  {
    status: ORDER_STATUS.COMPLETE,
    title: 'Hoàn thành',
    description:
      'Chúng tôi xin chân thành cảm ơn bạn đã mua hàng tại {TEN_NHA_CUNG_CAP}. Đơn hàng #{MA_DON_HANG} của bạn với tổng số tiền là {TONG_TIEN} đã được giao thành công. \nĐơn hàng của bạn đang chờ được thanh toán. Nếu bạn đã thanh toán đơn hàng, vui lòng bỏ qua thông báo này.',
    totalPrice: 700,
    image: completeStatusImage,
  },
];

const CUSTOMER_NOTIFICATION_ZALO_SETTING_FORM = [
  {
    status: ORDER_STATUS.PENDING,
    title: 'Xác nhận đặt hàng',
    description: `Cảm ơn quý khách hàng {TEN_KHACH_HANG} (mã khách hàng #{MA_KHACH_HANG}) đã tin tưởng mua hàng tại {TEN_THUONG HIEU}.
    Chúng tôi rất vui vì trong rất nhiều lựa chọn, bạn đã luôn chọn sử dụng các sản phẩm của {TEN_THUONG HIEU}.
    `,
    totalPrice: 500,
    image: zaloCustomerImage,
  },
];

export {
  areaTypeList,
  skeletonData,
  statusList,
  option,
  ACTION_TYPE,
  ZALO_NOTIFICATION_SETTING_SKELETON,
  NOTIFICATION_ZALO_SETTING_FORM,
  CONNECT_ZALO_SKELETON,
  CUSTOMER_NOTIFICATION_ZALO_SETTING_FORM,
};
